<template>
  <section class="index">

    <section class="content">
      <section>
        <div class="index_range_module">
          <span class="type_title">港股涨跌幅排行</span>
          <span class="type_up" :class="{active : isActive1}" @click="getHighData('netChange','desc')">涨</span>
          <span class="type_down" :class="{active : !isActive1}" @click="getLowData('netChange','asc')">跌</span>
          <a class="more" href="/market/marketRange/netChange" target="_blank">查看更多
            <span class="more_arrow">></span>
          </a>
        </div>
        <table class="table">
          <thead>
            <tr>
              <th>名称</th>
              <th>最新价</th>
              <th>涨跌额</th>
              <th>涨跌幅</th>
            </tr>
          </thead>
          <tbody>
            <tr class="up_range_data" v-for="item in netChange" :key="item.stockCode" @click="clickRowJump(item.stockType,item.stockCode)">
              <td>{{handleover(item.stockName)}}</td>
              <td :style="{'color':item.netChange>0 ? '#ED2C1D' : '#0FA538'}">{{item.currentPrice}}</td>
              <td :style="{'color':item.netChange>0 ? '#ED2C1D' : '#0FA538'}">{{item.change}}</td>
              <td :style="{'color':item.netChange>0 ? '#ED2C1D' : '#0FA538'}">{{(item.netChange*100).toFixed(2)}}%</td>
            </tr>
          </tbody>
        </table>
      </section>

      <section style="margin-top:20px;">
        <div class="index_range_module">
          <span class="type_title">港股成交额排行</span>
          <span class="type_up" :class="{active : isActive2}" @click="getHighData('turnVolume','desc')">高</span>
          <span class="type_down" :class="{active : !isActive2}" @click="getLowData('turnVolume','asc')">低</span>
          <a class="more" href="/market/marketRange/turnoverValue" target="_blank">查看更多
            <span class="more_arrow">></span>
          </a>
        </div>
        <table class="table">
          <thead>
            <tr>
              <!-- style="text-align:left;padding-left:10px;padding-bottom:10px;" -->
              <th>名称</th>
              <th>最新价</th>
              <th>涨跌幅</th>
              <th>成交额</th>
            </tr>
          </thead>
          <tbody>
            <tr class="up_range_data" v-for="item in turnVolume" :key="item.stockCode" @click="clickRowJump(item.stockType,item.stockCode)">
              <td>{{handleover(item.stockName)}}</td>
              <td :style="{'color':item.netChange>0 ? '#ED2C1D' : '#0FA538'}">{{item.currentPrice}}</td>
              <td :style="{'color':item.netChange>0 ? '#ED2C1D' : '#0FA538'}">{{(item.netChange*100).toFixed(2)}}%</td>
              <td :style="{'color':item.netChange>0 ? '#ED2C1D' : '#0FA538'}">{{(item.turnVolume/100000000).toFixed(2)}}亿</td>
            </tr>
          </tbody>
        </table>
      </section>

      <section style="margin-top:20px;">
        <div class="index_range_module">
          <span class="type_title">港股成交量排行</span>
          <span class="type_up" :class="{active : isActive3}" @click="getHighData('volume','desc')">高</span>
          <span class="type_down" :class="{active : !isActive3}" @click="getLowData('volume','asc')">低</span>
          <a class="more" href="/market/marketRange/turnoverVolume" target="_blank">查看更多
            <span class="more_arrow">></span>
          </a>
        </div>
        <table class="table">
          <thead>
            <tr>
              <th style="text-align:left;padding-left:10px;padding-bottom:10px;">名称</th>
              <th>最新价</th>
              <th>涨跌幅</th>
              <th>成交量</th>
            </tr>
          </thead>
          <tbody>
            <tr class="up_range_data" v-for="item in volume" :key="item.stockCode" @click="clickRowJump(item.stockType,item.stockCode)">
              <td>{{handleover(item.stockName)}}</td>
              <td :style="{'color':item.netChange>0 ? '#ED2C1D' : '#0FA538'}">{{item.currentPrice}}</td>
              <td :style="{'color':item.netChange>0 ? '#ED2C1D' : '#0FA538'}">{{(item.netChange*100).toFixed(2)}}%</td>
              <td :style="{'color':item.netChange>0 ? '#ED2C1D' : '#0FA538'}">{{(item.volume/100000000).toFixed(2)}}亿</td>
            </tr>
          </tbody>
        </table>
      </section>

    </section>
  </section>
</template>

<script>
import * as api from "~/api/index"
import { TSConstructorType, isUpdateExpression, awaitExpression } from 'babel-types';
export default {
  // props:['showSearch','display','netChange','turnVolume','volume'],
  data() {
    return {
      stockCode: null,
      stockList: [],
      showSearchFrame: false,
      isActive1: true, //涨跌幅 涨/跌是否被选中
      isActive2: true, //成交额 高/低是否被选中
      isActive3: true, //成交量 高/低是否被选中
      netChange: [],
      turnVolume: [],
      volume: []
    }
  },
  watch: {
    stockCode(val) {
      this.getStockList(val)
    }
  },
  mounted() {
    this.getNetChange()
    this.getTurnVolume()
    this.getVolume()
  },
  methods: {
    async getNetChange() {
      let netChange = await this.$axios(
        api.getMarketRange({
          sort: "netChange",
          order: "desc"
        })
      )
      this.netChange = netChange.result ? netChange.result : []

    },
    async getTurnVolume() {
      let turnVolume = await this.$axios(
        api.getMarketRange({
          sort: "turnVolume",
          order: "desc"
        })
      )
      this.turnVolume = turnVolume.result ? turnVolume.result : []
    },
    async getVolume() {
      let volume = await this.$axios(
        api.getMarketRange({
          sort: "volume",
          order: "desc"
        })
      )
      this.volume = volume.result ? volume.result : []
    },
    clickRowJump(type, code) {
      let routeUrl = this.$router.resolve({
        path: `/stock/${type.toLowerCase() + code}`
      })
      window.open(routeUrl.href, '_blank')
    },
    async getHighData(sort, order) {
      let highData = await this.$axios(
        api.getMarketRange({
          sort: sort,
          order: order
        })
      )
      if (sort == 'netChange') {
        this.netChange = highData.result ? highData.result : []
        this.isActive1 = true
      } else if (sort == 'turnVolume') {
        this.turnVolume = highData.result ? highData.result : []
        this.isActive2 = true
      } else if (sort == 'volume') {
        this.volume = highData.result ? highData.result : []
        this.isActive3 = true
      }

    },
    async getLowData(sort, order) {
      let lowData = await this.$axios(
        api.getMarketRange({
          sort: sort,
          order: order
        })
      )
      if (sort == 'netChange') {
        this.netChange = lowData.result ? lowData.result : []
        this.isActive1 = false
      } else if (sort == 'turnVolume') {
        this.turnVolume = lowData.result ? lowData.result : []
        this.isActive2 = false
      } else if (sort == 'volume') {
        this.volume = lowData.result ? lowData.result : []
        this.isActive3 = false
      }

    },
    getStockList(val) {
      if (val) {
        this.showSearchFrame = true
        this.$axios(
          api.getStockList({
            stockCodes: val
          })
        ).then(res => {
          let temp = res.result.stockList
          this.stockList = temp.splice(0, 5)
        }).catch(err => {
          console.log(err);
          return
        })
      } else {
        this.showSearchFrame = false
      }
    },
    //溢出字符显示省略号
    handleover(str) {
      if (str.length > 6) {
        let res = str.substring(0, 6) + '...'
        return res
      } else {
        return str
      }
    }
  }
}
</script>

<style lang="less" scoped>
.index {
  width: 100%;
  .title {
    display: inline-block;
    padding-bottom: 12px;
    border-bottom: 3px solid #3278d2;
    font-size: 18px;
    font-weight: bold;
    color: rgba(34, 34, 34, 1);
  }
}
.content {
  // display: flex;
  // justify-content: space-between;
  // width: 100%;
}
.content section {
  width: 100%;
  padding-top: 20px;
  background: #fff;
}
.type_title {
  width: 113px;
  height: 16px;
  font-size: 16px;
  font-weight: bold;
  color: rgba(34, 34, 34, 1);

  margin-right: 21px;
  margin-left: 21px;
}
.type_up {
  width: 16px;
  height: 16px;
  font-size: 16px;
  // font-weight:bold;
  // color:rgba(50,120,210,1);
  color: rgba(153, 153, 153, 1);
  margin-right: 8px;
}
.type_down {
  width: 16px;
  height: 15px;
  font-size: 16px;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
  margin-right: 54px;
}
.type_up:hover,
.type_down:hover {
  cursor: pointer;
}
.active {
  font-weight: bold;
  color: rgba(50, 120, 210, 1);
}

.more {
  font-size: 12px;
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
}
.more:hover {
  cursor: pointer;
}
.more_arrow {
  width: 5px;
  height: 8px;
  border-radius: 1px;
  margin-left: 3px;
}
.table {
  border-collapse: collapse;
  margin-left: 21px;
  tbody {
    tr {
      border-bottom: 1px dotted #e8e8e8;
    }
  }

  // .up_range_data:nth-child(odd) {
  //   background-color: #fafcff;
  // }
}
.up_range_data:hover {
  cursor: pointer;
  // box-shadow: 0px 2px 5px 0px rgba(91, 91, 91, 0.12)
}
.up_range_data {
  height: 40px;
  line-height: 40px;
  td:first-child {
    width: 100px;
    font-size: 14px;
    font-weight: 400;
    color: rgba(34, 34, 34, 1);
  }
  td:nth-child(2) {
    font-size: 14px;
    font-weight: bold;
    text-align: right;
  }
  td:nth-child(n + 3) {
    font-size: 14px;
    text-align: right;
  }
}

thead tr {
  font-size: 12px;
  font-weight: 400;
  color: #666666;
  th:first-child {
    text-align: left;
    padding-bottom: 10px;
    padding-top: 10px;
    width: 100px;
  }
  th:not(:first-child) {
    text-align: right;
  }
  th:nth-child(2) {
    width: 60px;
  }
  th:nth-child(3) {
    width: 60px;
  }
  th:last-child {
    width: 66px;
  }
}

// .table tr:first-child{
//   padding-bottom: 20px;
// }
// .table td:first-child{
//   width: 150px;
// }
.index_range_module {
  padding-bottom: 19px;
  border-bottom: 1px solid #f1f3f7;
}
</style>

